module.exports = __webpack_public_path__ + "img/periodical-policies.3037b21a.png";